module.exports = "data:image/gif;base64,R0lGODlhCgAKAKECAAAAAIeHh////////yH5BAEAAAIALAAAAAAKAAoAAAIUlI+pyxn/AIJxUnlowEZzAYTiUQAAOw=="